import { useParams } from 'react-router-dom'
import { Btn, InnerSidebar, useText } from '@kkf/design'
import { INNER_SIDEBAR } from '../data/inner-sidebar'
import { EVENT_DETAIL } from '../data/event-details'
import { eventBySlug } from '../data/events'
import { useT } from '../i18n'

/** The event-details page — resolved from `/events/:slug`. */
export function EventDetailsPage() {
  const t = useT()
  const s = useText()
  const { slug } = useParams()
  const event = eventBySlug(slug)
  const d = EVENT_DETAIL

  const metas = [
    { icon: 'calendar', text: event.season },
    { icon: 'pin', text: event.venue },
  ]

  return (
    <>
      {/* No banner and no breadcrumb (2026-09-21) — see `ContactPage` for the two things
          that travel with dropping one: the page's `<h1>`, which `Breadcrumb` used to
          carry, and `header.plainRoutes`, which nothing fails without. */}
      <div className="ul-container ul-section-spacing ul-plain-page-top">
        <div className="row gx-0 gy-4 flex-column-reverse flex-lg-row">
          {/* left sidebar */}
          <div className="col-lg-4">
            <InnerSidebar {...INNER_SIDEBAR} />
          </div>

          {/* event details content */}
          <div className="col-lg-8">
            <div className="ul-event-details ul-donation-details">
              <div className="ul-event-details-img">
                <img src={event.image} alt={t('alt.generic')} />
              </div>

              <div className="ul-event-details-infos">
                {metas.map((meta) => (
                  <div className="ul-event-details-info" key={s(meta.text)}>
                    <span className="icon">
                      <i className={`flaticon-${meta.icon}`} />
                    </span>
                    <span className="text">{s(meta.text)}</span>
                  </div>
                ))}
              </div>

              {/* The page's one `<h1>` — the event's own name, printed twice until
                  `Breadcrumb` came off: once in the band and once here. */}
              <h1 className="ul-event-details-title">{s(event.title)}</h1>
              {event.body.map((paragraph, i) => (
                <p className={i === 0 ? 'ul-event-details-descr' : undefined} key={s(paragraph)}>
                  {s(paragraph)}
                </p>
              ))}

              {/* "See Our Locations" and a map were here until 2026-09-03 — the
                  template's embed of a street in Dhaka. No event has a fixed venue yet, and
                  the venue each one does state is in the meta row above. See
                  `data/event-details.ts`. */}

              <h3 className="ul-event-inner-title">{d.contactTitle}</h3>
              <p>{t('comment.note')}</p>
              <form action="#" className="ul-contact-form ul-form" onSubmit={(e) => e.preventDefault()}>
                <div className="row row-cols-2 row-cols-xxs-1 ul-bs-row">
                  <div className="col">
                    <div className="form-group">
                      <input type="text" name="name" id="ul-contact-name" placeholder={t('form.name')} />
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <input type="email" name="email" id="ul-contact-email" placeholder={t('form.email')} />
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <input type="tel" name="phone" id="ul-contact-phone" placeholder={t('form.phone')} />
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <input type="text" name="subject" id="ul-contact-subject" placeholder={t('form.subject')} />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <textarea name="message" id="ul-contact-msg" placeholder={t('form.message')} />
                    </div>
                  </div>
                  <div className="col-12">
                    <Btn type="submit" icon="fast-forward-double-right-arrows-symbol">
                      {t('contact.eyebrow')}
                    </Btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
